<template>
  <div>
    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-static-table
          id="shop-order-payments-table"
          :fields="fields"
          :items="items"
          head-variant="light"
          ref="shop-order-payments-table"
          >

          <template #cell(empty)="data">

            <div class="d-flex justify-content-end">
              
            </div>
          </template>

        </memlist-static-table>
      </m-col>
    </m-row>
  </div>
</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';

export default {

  name: 'MemberShopOrderPaymentsTable',

  props: ['member', 'shop_order'],
  emits: ['selected', 'delete'],

  mixins: [toasts],

  components: {

  },

  watch: {
    shop_order: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        if (this.shop_order) {
          this.load_shop_order_payments(this.shop_order.shop_order_id);
        }
      }
    },
  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    edit_shop_order_payment_clicked(shop_order) {
      this.$nextTick(() => {
        this.$emit('selected', shop_order);
      });
    },

    delete_shop_order_payment_clicked(shop_order) {
      this.$nextTick(() => {
        this.$emit('delete', shop_order);
      });
    },

    async load_shop_order_payments(shop_order_id) {
      try {
        const res = await axios.get(`/shop_order/${shop_order_id}/payments`);

        if (res.status === 200) {
          this.items = res.data;
        }
      }
      catch (err) {
        console.error('load_shop_order_payments error', err)
      }
    },


  },

  async mounted() {

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }

    if (this.shop_order) {
      await this.load_shop_order_payments(this.shop_order.shop_order_id);
    }

  },

  data() {
    return {

      items: [],

      fields: [

        {
          key: 'created_at',
          label: this.$t('SHOP_ORDER.PAID_AT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short5',
          thClass: 'td-short5',
          
        },
        {
          key: 'amount',
          label: this.$t('SHOP_ORDER.PAYMENT_AMOUNT'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4',
          
        },
        {
          key: 'payment_method',
          label: this.$t('SHOP_ORDER.PAYMENT_METHOD'),
          sortable: false,
          mobile: true,
          formatter: (_, __, item) => {
            return item.payment_method.toUpperCase()
          },
          tdClass: 'td-short4',
          thClass: 'td-short4',
        },
        {
          key: 'empty',
          label: '',
          thClass: ''
        }
      ],

      show_form: true,

    };
  }
};

</script>
<style lang="scss" scoped>
  
  
</style>
